import React, { useRef, useState } from 'react';
import { iconeType } from '../utils';

export default function SaisieZone({ onEnvoyer, fichiers, onAjouterFichiers, onSupprimerFichier, enCours }) {
  const [texte, setTexte] = useState('');
  const textareaRef = useRef(null);
  const fileRef = useRef(null);

  const handleEnvoyer = () => {
    if ((!texte.trim() && !fichiers.length) || enCours) return;
    onEnvoyer(texte);
    setTexte('');
    if (textareaRef.current) { textareaRef.current.style.height = 'auto'; }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleEnvoyer(); }
  };

  const handleInput = (e) => {
    setTexte(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
  };

  return (
    <div style={styles.wrap}>

      {/* Preview fichiers */}
      {fichiers.length > 0 && (
        <div style={styles.preview}>
          {fichiers.map(f => (
            <div key={f.id} style={styles.prevItem}>
              <span style={styles.prevIcn}>{iconeType(f.type)}</span>
              <span style={styles.prevNom} title={f.nom}>{f.nom}</span>
              <button style={styles.prevDel} onClick={() => onSupprimerFichier(f.id)}>✕</button>
            </div>
          ))}
        </div>
      )}

      <div style={styles.row}>
        {/* Bouton upload discret */}
        <div style={styles.btnPjWrap} title="Joindre un fichier">
          <span>📎</span>
          {fichiers.length > 0 && (
            <span style={styles.badge}>{fichiers.length}</span>
          )}
          <input
            ref={fileRef}
            type="file"
            multiple
            accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt,.csv"
            style={styles.fileInput}
            onChange={(e) => { onAjouterFichiers(e.target.files); e.target.value = ''; }}
          />
        </div>

        {/* Textarea */}
        <textarea
          ref={textareaRef}
          style={styles.input}
          placeholder="Écrivez un message…"
          rows={1}
          value={texte}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
        />

        {/* Bouton envoyer */}
        <button
          style={{ ...styles.btnSend, ...(enCours ? styles.btnSendDisabled : {}) }}
          onClick={handleEnvoyer}
          disabled={enCours}
        >
          ➤
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { background: '#f0f0f0', padding: '.55rem .7rem', flexShrink: 0 },
  preview: {
    display: 'flex', flexWrap: 'wrap', gap: '.35rem',
    marginBottom: '.45rem', padding: '.45rem .6rem',
    background: '#fff', borderRadius: 12,
  },
  prevItem: {
    display: 'flex', alignItems: 'center', gap: '.4rem',
    background: '#f0f4f8', borderRadius: 20,
    padding: '.25rem .6rem .25rem .45rem',
    fontSize: '.74rem', fontWeight: 500, color: '#333',
    border: '1px solid #dce4ef',
  },
  prevIcn: { fontSize: '.9rem' },
  prevNom: { maxWidth: 110, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  prevDel: { background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: '.9rem', padding: 0, lineHeight: 1 },
  row: { display: 'flex', alignItems: 'flex-end', gap: '.5rem' },
  btnPjWrap: {
    position: 'relative',
    width: 42, height: 42, borderRadius: '50%',
    background: '#fff', border: 'none', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '1.2rem', color: '#777', flexShrink: 0,
    boxShadow: '0 1px 3px rgba(0,0,0,.1)',
  },
  badge: {
    position: 'absolute', top: -2, right: -2,
    background: '#e74c3c', color: '#fff',
    width: 16, height: 16, borderRadius: '50%',
    fontSize: '.6rem', fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    border: '1.5px solid #f0f0f0',
  },
  fileInput: { position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer', width: '100%', height: '100%' },
  input: {
    flex: 1, background: '#fff', border: 'none', borderRadius: 22,
    padding: '.6rem 1rem', fontSize: '.9rem', fontFamily: 'Inter, sans-serif',
    color: '#111', outline: 'none', resize: 'none',
    minHeight: 42, maxHeight: 120, lineHeight: 1.45,
    boxShadow: '0 1px 3px rgba(0,0,0,.08)',
  },
  btnSend: {
    width: 42, height: 42, borderRadius: '50%',
    background: '#1a3a5c', border: 'none', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', fontSize: '1.1rem', flexShrink: 0,
    boxShadow: '0 2px 6px rgba(26,58,92,.35)',
  },
  btnSendDisabled: { background: '#c5c5c5', boxShadow: 'none', cursor: 'not-allowed' },
};
